define(
    'Tavanoteam.TavanoTeam_Slider_Extension.Slider'
    , [
        'Slider.View'
    ]
    , function (
        SliderView
    ) {

        'use strict';

        return {

            mountToApp: function mountToApp(container) {

                container.getComponent('CMS').registerCustomContentType({
                    id: 'cct_tavanoteam_slider'
                    , view: SliderView
                    , options: {
                        container: container
                    }
                });
            }
        };
    }
);
